(function () {
    'use strict';

    angular
        .module('app.opsConfig')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'opsconfig',
                config: {
                    url: '/opsconfig',
                    templateUrl: 'app/opsconfig/opsconfig.html?v=' + opsIncludeVersion,
                    controller: 'OpsConfigController',
                    controllerAs: 'vm',
                    title: 'Config',
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            userService.isAuthenticatedThrowError();
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            }
        ];
    }
})();
